/**
 * Created by Jerker Nord on 2020-03-25.
 */
import {
    GameIntroColors,
    GameIntroViewConfig, StampConfig, Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BonusBunniesGameAssets} from "../BonusBunniesGameAssets";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesIntroStartPage} from "./BonusBunniesIntroStartPage";
import {BonusBunniesIntroPage} from "./BonusBunniesIntroPage";

export class BonusBunniesIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x432215,
            backgroundAlpha : 1,
            bulletColor : 0xffffff
        },
        stampColor : 0xFFFFFF,
    };

    stampConfig:StampConfig = {
        xWays : false,
        xNudge : false,
        volatility : Volatility.MEDIUM
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];
    bgBlack:PIXI.Sprite;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(BonusBunniesGameAssets.INTRO_BORDER_TILE_TOP, BonusBunniesGameAssets.INTRO_BORDER_TILE_TOP);
        imgLoader.add(BonusBunniesGameAssets.INTRO_BORDER_TILE_BOTTOM, BonusBunniesGameAssets.INTRO_BORDER_TILE_BOTTOM);
        imgLoader.add(BonusBunniesGameAssets.PROMO_FREESPIN, BonusBunniesGameAssets.PROMO_FREESPIN);
        imgLoader.add(BonusBunniesGameAssets.INTRO_BLURRED_BACKGROUND, BonusBunniesGameAssets.INTRO_BLURRED_BACKGROUND);
        imgLoader.add(BonusBunniesGameAssets.INTRO_FEATURE_ALL, BonusBunniesGameAssets.INTRO_FEATURE_ALL);
        imgLoader.add(BonusBunniesGameAssets.INTRO_FEATURE_1, BonusBunniesGameAssets.INTRO_FEATURE_1);
        imgLoader.add(BonusBunniesGameAssets.INTRO_FEATURE_2, BonusBunniesGameAssets.INTRO_FEATURE_2);
        imgLoader.add(BonusBunniesGameAssets.INTRO_FEATURE_3, BonusBunniesGameAssets.INTRO_FEATURE_3);
        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x000000;
        this.background.addChild(this.bgBlack);
        const blurredBackground = new PIXI.Sprite(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_BLURRED_BACKGROUND));
        blurredBackground.anchor.set(0.5, 0.5);
        blurredBackground.scale.set(2, 2);
        this.background.addChild(blurredBackground);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_BORDER_TILE_TOP));
        topSprite.anchor.set(0.5, 0.79);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_BORDER_TILE_BOTTOM));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.47);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();

        const featureText1 = SlotGame.api.translations.translate("Bonus + Wild will create a Wild expansion vertically and horizontally.");
        const featureText2 = SlotGame.api.translations.translate("Landing 3 or more Bonus will trigger Carrot Link Spins.");
        const featureText3 = SlotGame.api.translations.translate("A win in Carrot Link Spins resets the spin meter. All wins displayed as times the bet.");

        this.pages = [
            new BonusBunniesIntroStartPage(),
            new BonusBunniesIntroPage(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_FEATURE_1), featureText1),
            new BonusBunniesIntroPage(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_FEATURE_2), featureText2),
            new BonusBunniesIntroPage(ImgLoader.getImgTexture(BonusBunniesGameAssets.INTRO_FEATURE_3), featureText3)
        ];

    }

    onResize(): void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }
}
